import { render, staticRenderFns } from "./PromotionDetailsSection.vue?vue&type=template&id=864212ea&scoped=true"
import script from "./PromotionDetailsSection.vue?vue&type=script&lang=js"
export * from "./PromotionDetailsSection.vue?vue&type=script&lang=js"
import style0 from "./PromotionDetailsSection.vue?vue&type=style&index=0&id=864212ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864212ea",
  null
  
)

export default component.exports